import { Services, getPrice } from '@sigma-frontend-libs/commons'

import { isEmpty, proxy } from '@/utils'

import render from './render'

const baseClass = 'packets'

export default {
  name: 'Packets',

  mixins: [ proxy({ type: 'array' }) ],

  props: {
    readonly: Boolean
  },

  data() {
    return {
      showDialog: false
    }
  },

  methods: {
    normalizePackets() {
      if (Array.isArray(this.proxy)) {
        this.proxy = this.proxy.map(({ price, size }, index) => {
          return {
            price,
            size,
            priority: index
          }
        })

        return
      }

      this.proxy = []
    },

    remove(index) {
      if (!isEmpty(index)) {
        this.proxy.splice(index, 1)
      } else {
        this.proxy = []
      }

      this.normalizePackets()
    },

    getItemValue(item, field) {
      switch (field) {
        case 'size': return item.size
        case 'price': return getPrice(item.price)
        case 'priority': return item.priority + 1
        default: return item[field]
      }
    },
    getTagTooltip(item) {
      const fields = [ 'priority', 'size', 'price' ]
      const result = fields.map(field => {
        return [
          this.getTranslate(`${Services.tariffs}.labels.${baseClass}.${field}`),
          this.getItemValue(item, field)
        ].join(': ')
      })

      return result.join('\n')
    }
  },

  render
}
